import config from '../config';
import { formatMoney } from './currency';
import { types as sdkTypes } from './sdkLoader';

const { Money } = sdkTypes;

export const getLtPlusMonthlyPriceMoney = (currency = config.currency) =>
  new Money(config.landtrustPlusMonthlyPriceSubUnits, currency);

export const formatLtPlusMonthlyPrice = (intl, currency = config.currency) =>
  formatMoney(intl, getLtPlusMonthlyPriceMoney(currency));
